exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.expand-button[data-v-48495f08] {\n  border-radius: 4px;\n  color: #2a2e51;\n  background: #f2f3fd;\n}\n.expand-button-header[data-v-48495f08] {\n  display: flex;\n  padding: 4px 12px;\n  justify-content: space-between;\n}\n.expand-button-body[data-v-48495f08] {\n  border-top: 1px solid #b1b4cd;\n  height: 200px;\n  padding: 4px 12px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48495f08","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/usr/src/app/src/assets/_include-media.scss","/usr/src/app/src/assets/palette.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/expandButton.vue
// module id = Iq/D
// module chunks = 1